import { FC } from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import { CardBrandProps } from "./types";
import { ERoutes } from "../../constants/routes";
import { getBrandCardElementId } from "@/view/Brands/utils/brandsNavigation";
import {
  selectDailyAverageBrandScoresState,
  selectDailyAverageBrandLoadingState,
  selectWeeklyBrandScoresState,
  selectBrandRangeValuesState,
} from "../../store/selectors/scores";
import CardChartWithCalendar from "../CardChartWithCalendar";

import styles from "./CardBrand.module.css";



const CardBrand: FC<CardBrandProps> = ({ brand, defaultIsOpen = false }) => {
  const navigate = useNavigate();
  const dailyAverageBrandLoading = useSelector(selectDailyAverageBrandLoadingState);
  const weeklyScores = useSelector(selectWeeklyBrandScoresState(brand.id));
  const dailyAverageBrandScores = useSelector(selectDailyAverageBrandScoresState(brand.id));
  const rangeValues = useSelector(selectBrandRangeValuesState);

  const handleDotClick = (created_at: string) => {
    const formattedDate = format(new Date(created_at), 'yyyy-MM-dd');
    navigate(ERoutes.PromptsDayly.replace(":id", String(brand.id)).replace(":date", formattedDate));
  }

  return (
    <CardChartWithCalendar
      item={brand}
      type="brand"
      htmlId={getBrandCardElementId(brand.id)}
      defaultIsOpen={defaultIsOpen}
      customTitleClassName={styles["card-brand__title"]}
      rangeValues={rangeValues || undefined}
      dailyAverageLoading={dailyAverageBrandLoading}
      dailyAverageScores={dailyAverageBrandScores}
      weeklyScores={weeklyScores || undefined}
      weeklyScoresLoading={dailyAverageBrandLoading}
      onDotClick={handleDotClick}
    />
  );
};

export default CardBrand;
